'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { User } from '@qogita/canary-client'
import * as Sentry from '@sentry/nextjs'
import { use, useEffect } from 'react'

export function IdentifySentryUser({
  userPromise,
}: {
  userPromise: Promise<User | null>
}) {
  const user = use(userPromise)

  useEffect(() => {
    if (user?.qid) {
      Sentry.setUser({ id: user.qid })
    } else {
      Sentry.setUser(null)
    }
  }, [user?.qid])

  return null
}
